import { Text, View } from 'react-native'
import React from 'react'
import ChatIcon from '../Shortcuts/assets/WhiteChat.svg'
import ArrowDown from '../Shortcuts/assets/ArrowDown.svg'
import { IconButton } from '../IconButton'
import { styles } from './ChatPreview.styles'
import { observer } from 'mobx-react-lite'
import { useTypingIndicator } from '../../../screens/new-design/hooks/useTypingIndicator'

type ChatPreviewProps = {
  onChat: () => void
}

const ChatPreview = observer(({ onChat }: ChatPreviewProps) => {
  const { chatMessage } = useTypingIndicator()
  return (
    <View>
      <IconButton onPress={onChat}>
        <View style={styles.bubbleChatContainer}>
          <View style={{ position: 'absolute', left: 12 }}>
            <ChatIcon />
          </View>
          <Text style={styles.chatText} numberOfLines={1}>
            {chatMessage}
          </Text>
          <View style={{ position: 'absolute', right: 12 }}>
            <ArrowDown />
          </View>
        </View>
      </IconButton>
    </View>
  )
})

export default ChatPreview
